// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cFta","top":"styles_top__bX28S"};